"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getters = void 0;
var getters = {
  isAdmin: function isAdmin(state) {
    return state.isAdmin;
  },
  isLogIn: function isLogIn(state) {
    return state.isLogIn;
  },
  userKey: function userKey(state) {
    return state.isLogIn ? state.userKey : '';
  },
  lfToken: function lfToken(state) {
    return state.isLogIn ? state.lfToken : '';
  },
  lfCustKey: function lfCustKey(state) {
    return state.isLogIn ? state.lfCustKey : '';
  },
  lfAPIToken: function lfAPIToken(state) {
    return state.isLogIn ? state.lfAPIToken : '';
  },
  userInformation: function userInformation(state) {
    return state.isLogIn ? state.userInformation : {};
  },
  userData: function userData(state) {
    return state.isLogIn ? state.userData : {};
  },
  userSetting: function userSetting(state) {
    return state.isLogIn ? state.userSetting : {};
  }
};
exports.getters = getters;